export function notificationDeeplinkActionLabel(
  deeplink: string | null | undefined
): string {
  if (!deeplink) return "Abrir";
  if (deeplink.startsWith("/obrasprivadas/")) return "Ver obra";
  if (deeplink.startsWith("/cotizaciondemateriales/")) return "Ver cotización";
  if (deeplink.startsWith("/bolsa-trabajo/")) return "Ver aviso";
  if (deeplink.includes("tab=servicios")) return "Ver portfolio";
  if (deeplink.includes("tab=calificaciones")) return "Ver calificaciones";
  if (deeplink.startsWith("/perfil/")) return "Ver perfil";
  if (deeplink.startsWith("/marketplace")) return "Ver publicaciones";
  if (deeplink === "/dashboard" || deeplink.startsWith("/dashboard/"))
    return "Ir al inicio";
  if (deeplink === "/obrasprivadas") return "Ver obras privadas";
  if (deeplink === "/cotizaciondemateriales") return "Ver cotizaciones";
  return "Abrir";
}
